import * as MutationsType from "./mutationsType";
import requestAxios from "@/helpers/request_axios";

export default {
  async getFileById({ commit, state }, { id }) {
    try {
      let file = (state.files || []).find((file) => file.id === id);
      if (!file) {
        let response = await requestAxios({
          url: `/awy/api/v1/files/${id}`,
          method: "GET",
        });

        file = response.data.data;
      }

      commit(MutationsType.SET_BUSINESS_FILE, file);
    } catch (error) {
      throw error.response.data;
    }
  },
  async getAllFiles({ commit }) {
    try {
      let response = await requestAxios({
        url: "/awy/api/v1/files",
        method: "GET",
      });

      commit(MutationsType.SET_BUSINESS_FILES, response.data.data);
    } catch (error) {
      throw error.response.data;
    }
  },
  async createFile({ commit, state }, { data }) {
    try {
      let response = await requestAxios({
        url: "/awy/api/v1/files",
        method: "POST",
        data: data,
      });

      if (state.files) commit(MutationsType.ADD_BUSINESS_FILE, response.data.data);

      return response.data.data;
    } catch (error) {
      throw error.response.data;
    }
  },
  async updateFile({ commit }, { id, data }) {
    try {
      let response = await requestAxios({
        url: `/awy/api/v1/files/${id}`,
        method: "PATCH",
        data: data,
      });

      commit(MutationsType.UPDATE_BUSINESS_FILE, response.data.data);

      return response.data.data;
    } catch (error) {
      throw error.response.data;
    }
  },
  async deleteFile({ commit }, { id }) {
    try {
      await requestAxios({
        url: `/awy/api/v1/files/${id}`,
        method: "DELETE",
      });

      commit(MutationsType.DELETE_BUSINESS_FILE, { id });
    } catch (error) {
      throw error.response.data;
    }
  },
  resetModuleFiles({ commit }) {
    commit(MutationsType.SET_BUSINESS_FILES, null);
  },
};
